var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    stroke: "#222",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4 6a1 1 0 0 1 1-1h6.083a1 1 0 0 1 .923.615l.738 1.77a1 1 0 0 0 .923.615H21a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    stroke: "#222",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.27 12.217A1 1 0 0 1 2.247 11h15.95a1 1 0 0 1 .977.783l1.556 7A1 1 0 0 1 19.753 20H3.803a1 1 0 0 1-.977-.783z"
  })));
};
export default SvgFolder;